import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

const usePermissions = () => {
	const userRole = useSelector((state) => state?.authtentication?.user?.user?.permissions)
	const hasPermission = (permissionsName) => {
		if (permissionsName) {
			return userRole?.includes(permissionsName)
		}
		return true
	}
	return { hasPermission }
}

export default usePermissions
